import React from 'react';
import { WithTranslation, withTranslation } from 'react-i18next';
import styled from 'styled-components/macro';

import { colors, distances, border } from '../../styles/constants';
import Card from '../../components/Card';
import { H3 } from '../../components/Typography';
import { DraftOrder, Order } from '../../types/orders';
import ExpandCollapseJson from './ExpandCollapseJson';
import Hr from '../../components/Hr';
export interface MetadataProps extends WithTranslation {
    draftOrOrder: DraftOrder | Order;
}

const getMetadata = (draftOrOrder: DraftOrder | Order) => {
    if ((draftOrOrder as DraftOrder).order) {
        return (draftOrOrder as DraftOrder).order.metadata;
    }
    if (draftOrOrder as Order) {
        return (draftOrOrder as Order).metadata;
    }
    return undefined;
};

const Metadata = (
    {
        t,
        draftOrOrder,
    }: MetadataProps
) => {
    const metadata = getMetadata(draftOrOrder);

    if (!metadata) {
        return null;
    }
    return (
        <Card marginBottom={distances.normal}>
            <H3>{t('orders.fields.metadata')}</H3>
            <Hr />
            <ExpandCollapseJson
                label={<strong>{t('orders.fields.click_to_expand_metadata')}</strong>}
                json={metadata}
            />
        </Card>
    );
};

export default withTranslation()(Metadata);
